import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { useContext } from './Context'
import { BlogContainer } from '@ztechapps/blog.webui'
import { PostEmptyContent } from '../../../components/PostEmptyContent'
import { DataSuspense } from '@ztechapps/webui.util'
import PageTitle from '../../../components/PageTitle'

export const Layout = () => {
  const { document, error, loading } = useContext()
  return (
    <>
      <PageTitle
        title={`Use and Care Guides - ${document?.title}`}
        description="Learn how to properly use and care for your PanelPunches products with our comprehensive guides."
      />
      <DataSuspense error={error} loading={loading} isEmpty={isEmpty(document)} emptyComponent={<PostEmptyContent />}>
        <BlogContainer blog={document} />
      </DataSuspense>
    </>
  )
}
